import { Component, Input } from "@angular/core";
import { GridOptions } from "ag-grid";
import { BaseComponent } from "../base.component";
import { HistoryDetailComponent } from "./history_detail.component";
import * as $ from "jquery";
import * as moment from "moment";
import { SessionManagerService } from "../_services/SessionManager/session-manager.service";
import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "history",
  templateUrl: "history.component.html",
  styleUrls: ["./history.component.scss"],
})
export class HistoryComponent extends BaseComponent {
  @Input() nestId?: number;
  @Input() registeredUser?: any;
  model: any = {};
  loading = false;
  messages: any;
  width = 160;
  smallWidth = 70;
  historyPayments: any;
  public gridOptions: GridOptions;
  public rowSelection;
  public context;
  public gridApi: any;
  public openedPanel: boolean = false;
  public screenWidth: number;

  constructor(
    public dataService: DataService,
    public alertService: AlertService,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
    this.screenWidth = window.innerWidth;
  }

  run() {
    this.rowSelection = `single`;
    this.context = { componentParent: this };
    this.gridOptions = <GridOptions>{};
    this.gridOptions.enableRtl = true;
    this.gridOptions.rowHeight = 50;
    this.gridOptions.rowClass = "paymentRow";
    this.gridOptions.enableColResize = true;
    this.gridOptions.icons = {
      groupExpanded: '<i class="fa fa-arrow-circle-right"/>',
      groupContracted: '<i class="fa fa-arrow-circle-down"/>',
    };
    let sizeModifier = 1;
    const screenDesktopSize = 966;
    if (this.screenWidth < screenDesktopSize) {
      sizeModifier = this.screenWidth / screenDesktopSize;
    }
    this.gridOptions.columnDefs = this.isUserMeshutaf()
      ? [
          {
            headerName: this.base.messages["payment"],
            field: `paymentDate`,
            width: this.width * sizeModifier,
            cellRenderer: this.dateFormatter,
          },
          {
            headerName: this.base.messages["event"],
            field: `eventName`,
            width: 250 * sizeModifier,
          },
          {
            headerName: this.base.messages["numberOfChildren"],
            field: `numberOfChildrenHTML`,
            cellRenderer: function (params) {
              return params.value;
            },
            width: this.width * sizeModifier,
          },
          {
            headerName: this.base.messages["amount"],
            field: `totalAmountHTML`,
            cellRenderer: function (params) {
              return params.value;
            },
            width: this.width * sizeModifier,
          },
          {
            headerName: this.base.messages["status"],
            field: `statusHTML`,
            cellRenderer: function (params) {
              return params.value;
            },
            width: this.width * sizeModifier,
          },
          {
            headerName: "",
            width: this.smallWidth,
            cellRenderer: "group",
            cellRendererParams: { suppressCount: true },
          },
        ]
      : [
          {
            headerName: this.base.messages["payment"],
            field: `paymentDate`,
            width: this.width * sizeModifier,
            cellRenderer: this.dateFormatter,
          },
          {
            headerName: this.base.messages["event"],
            field: `eventName`,
            width: 200 * sizeModifier,
          },
          {
            headerName: this.base.messages["amount"],
            field: `finalPrice`,
            width: this.smallWidth * sizeModifier,
          },
          {
            headerName: this.base.messages["child"],
            field: `childName`,
            width: (this.smallWidth + 50) * sizeModifier,
          },
          {
            headerName: this.base.messages["status"],
            field: `statusName`,
            width: this.width * sizeModifier,
          },
          {
            headerName: "",
            width: this.smallWidth,
            cellRenderer: "group",
            cellRendererParams: { suppressCount: true },
          },
        ];
    this.gridOptions.rowData = [];
    if (this.isUserRegular()) {
      this.getHistory();
    }
  }

  dateFormatter(params) {
    return params.value ? moment(params.value).format("DD-MM-YYYY") : "";
  }

  onGridReady(params) {
    this.gridApi = params.api;
  }

  methodFromParent() {
    this.getHistory();
  }

  public getHistory() {
    $(".paymentsContainer").slideToggle("fast");
    if (!this.openedPanel) {
      this.loading = true;

      this.historyPayments = [];
      this.addObservable(
        this.dataService
          .getHistory(
            this.nestId,
            this.registeredUser && this.registeredUser.id
              ? this.registeredUser.id
              : undefined
          )
          .subscribe(
            (data) => {
              this.loading = false;
              this.historyPayments = data;

              this.gridOptions.rowData = this.historyPayments;
            },
            () => {
              this.loading = false;
            }
          )
      );
    }
    this.openedPanel = !this.openedPanel;
  }

  public getFullWidthCellRenderer() {
    return HistoryDetailComponent;
  }

  public getNodeChildDetails(payment) {
    if (payment) {
      return {
        group: true,
        // the key is used by the default group cellRenderer

        field: payment.paymentId,
        // provide ag-Grid with the children of this group
        children: [payment.txId],
        // for demo, expand the third row by default
        //                 expanded: payment.id == 1201
      };
    } else {
      return null;
    }
  }

  public isFullWidthCell(rowNode) {
    return rowNode.level === 1;
  }

  public getRowHeight(params) {
    const rowIsDetailRow = params.node.level === 1;
    // return 100 when detail row, otherwise return 25
    return rowIsDetailRow
      ? params.data && params.data.isMeshutafPayment
        ? 300
        : 200
      : params.data && params.data.isMeshutafPayment
      ? 90
      : 50;
  }
}



// WEBPACK FOOTER //
// ./src/app/payment/history.component.ts